import SurveyFormContent from '../../Form/FormContent'

const SurveyFormTab: React.FC = () => {
  return <SurveyFormContent />
}

export default SurveyFormTab
